import { useCallback, useEffect, useMemo, useState } from "react";
import dayjs from "dayjs";
import { getTransportGroupsByDate } from "../api/transportApi.js";

export default function useTransportGroupsByDate(selectedDate, { enabled = true } = {}) {
  const [groups, setGroups] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const dateStr = useMemo(
    () => (selectedDate ? selectedDate.format("YYYY-MM-DD") : dayjs().format("YYYY-MM-DD")),
    [selectedDate]
  );

  const refetch = useCallback(
    async (date = selectedDate) => {
      const ds = (date ? date.format("YYYY-MM-DD") : dayjs().format("YYYY-MM-DD"));

      setLoading(true);
      setError(null);
      try {
        const data = await getTransportGroupsByDate(ds);
        setGroups(Array.isArray(data) ? data : []);
        return data;
      } catch (e) {
        console.error("[useTransportGroupsByDate] fetch failed:", e);
        setError(e);
        setGroups([]);
        return [];
      } finally {
        setLoading(false);
      }
    },
    [selectedDate]
  );

  useEffect(() => {
    if (!enabled) return;
    refetch(selectedDate);
  }, [enabled, refetch, selectedDate]);

  return { groups, loading, error, refetch, dateStr };
}
